import React from 'react'
import MyPageComp from '../../../../components/main/login/mypage/MyPageComp'


export const MyPage = () => {
  return (
    <div style={{backgroundColor: '#F3F5F6',
      minHeight: '140vh'}}>
      <MyPageComp/>
    </div>
  )
}
